import homeSearchIcon from "./homeSearchIcon.svg";
import newListingIcon from "./newListingIcon.svg";
import questionsSupportIcon from "./questionsSupportIcon.svg";
import savedListingIcon from "./savedListingIcon.svg";

export {
  questionsSupportIcon,
  savedListingIcon,
  newListingIcon,
  homeSearchIcon
};
